<div class="dialog-overlay" *ngIf="isDialogOpen" [ngClass]="{ 'closing': isClosing }">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ title }}</h2>
      <button class="close-btn" aria-label="Close" (click)="closeDialog()">
        &times;
      </button>
    </div>

    <div class="dialog-body">
      <ng-content>
        <p class="dialog-message" *ngIf="message">{{ message }}</p>
      </ng-content>
    </div>

    <div class="dialog-actions">
      <button class="aecom_btn" (click)="closeDialog()">{{ closeButtonText || 'Close' }}</button>
      <button class="aecom_btn--solid" *ngIf="confirmButtonText" (click)="confirmAction()">
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
</div>